import { render, staticRenderFns } from "./pogs-form--user.vue?vue&type=template&id=4d9bd9c7&"
import script from "./pogs-form--user.vue?vue&type=script&lang=js&"
export * from "./pogs-form--user.vue?vue&type=script&lang=js&"
import style0 from "./pogs-form--user.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports